import React, { useEffect, useState } from 'react';
import Loader from './Loader';
import axios from 'axios';
import Main from './Main';
import BlogCards from './BlogCards';
import Sidebar from './Sidebar';
import { useDispatch } from 'react-redux';
import { loadMessages, addLikes, disLikes } from './actions';
import { useBlogContext } from '../Context/BlogContext';
import { useHistory } from 'react-router-dom';

const Blogs = () => {
  const { blogs, loading, error, currentUser } = useBlogContext();

  const [search, setSearch] = useState('');

  const dispatch = useDispatch();

  const history = useHistory();

  useEffect(() => {
    dispatch(
      loadMessages({
        loading: true,
        post: null,
        error: false,
      })
    );

    axios
      .get(
        `https://610fed18c848c900171b3a0f.mockapi.io/api/v1/posts?search=${search}`
      )
      .then((response) => {
        console.log(response);
        dispatch(
          loadMessages({
            loading: false,
            post: response.data,
            error: false,
          })
        );
      })
      .catch(() => {
        dispatch(
          loadMessages({
            loading: false,
            post: null,
            error: true,
          })
        );
      });
  }, [search, dispatch]);

  let check = 'No Post To Display';

  loading && (check = <Loader />);
  error && (check = 'Oooops! An Error ocurred');

  const handleLikes = (id) => {
    if (!currentUser.uuid) {
      history.push('/login');
    } else {
      const add = blogs.find((item) => item.id === id);
      console.log(add);

      axios({
        method: 'PUT',
        url: `https://610fed18c848c900171b3a0f.mockapi.io/api/v1/posts/${id}`,
        data: {
          ...add,
          likes: [
            ...add.likes,
            {
              name: currentUser.firstName,
              like: true,
              uid: currentUser.uuid,
            },
          ],
        },
      });

      dispatch(
        addLikes({
          id: id,
          data: {
            name: currentUser.firstName,
            uid: currentUser.uuid,
            like: true,
          },
        })
      );
    }
  };

  const handleDisLikes = (id) => {
    const add = blogs.find((item) => item.id === id);

    const Adds = add.likes.filter((item) => item.uid !== currentUser.uuid);

    axios({
      method: 'PUT',
      url: `https://610fed18c848c900171b3a0f.mockapi.io/api/v1/posts/${id}`,
      data: {
        ...add,
        likes: Adds,
      },
    });

    dispatch(disLikes({ id: id, data: Adds }));
  };

  return (
    <div className='blog flex flex-col  min-h-screen'>
      <Main />
      <div className='w-11/12 flex mt-10 mx-auto md:flex-row flex-col gap-16'>
        <div className='w-full mb-10  md:w-3/12'>
          <Sidebar search={search} setSearch={setSearch} blogs={blogs} />
        </div>

        <div className='w-full md:w-8/12'>
          {blogs?.length > 0
            ? blogs.map((blog) => (
                <BlogCards
                  key={blog.id}
                  blog={blog}
                  handleLikes={handleLikes}
                  handleDisLikes={handleDisLikes}
                />
              ))
            : check}
        </div>
      </div>
    </div>
  );
};

export default Blogs;
